import { ConfigType } from 'dayjs';
import { Box, Grid, SxProps, TimeSelector } from '@methanesat/ui-components';
import { DrawerCardContentHeader } from '../EmissionsPageMap/LayerDataDrawer/Headers/DrawerCardContentHeader';
import { useSelector } from 'react-redux';
import { selectPlatform } from '../../reducers';
import { getGlobalDateOptions, getTimeSelectorTimespan } from '../../consts';
import { StacTimeSelectorData } from '../../types';

export const TargetSummaryLayout = ({
    data,
    emissions,
    emissionsTitle,
    sx,
    title,
    targetOrGroupId,
    selectedValue
}: {
    data: StacTimeSelectorData;
    emissions: string;
    emissionsTitle: string;
    overTimeTitle: string;
    sx?: SxProps;
    title: string;
    targetOrGroupId: string;
    selectedValue: ConfigType;
}) => {
    const platform = useSelector(selectPlatform);
    return (
        <Box
            height="100%"
            sx={[
                {
                    width: 'fit-content',
                    maxWidth: '100% !important'
                },
                ...(Array.isArray(sx) ? sx : [sx])
            ]}
        >
            <Grid container flexDirection="column" maxWidth="inherit">
                <Grid marginBottom={1}>
                    <Grid container flexDirection="column" sx={[{}, ...(Array.isArray(sx) ? sx : [sx])]}>
                        <Grid size="grow">
                            <DrawerCardContentHeader
                                titleLabel={title}
                                titleValue={targetOrGroupId}
                                /** Magic number to accommodate absolute positioned close button */
                                sx={{ '& .MuiGrid2-root:nth-child(2)': { maxWidth: '140px' } }}
                            />
                        </Grid>
                        <Grid size="grow">
                            <DrawerCardContentHeader titleLabel={`${emissionsTitle}: `} titleValue={emissions} />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid maxWidth="inherit" sx={{ position: 'relative' }}>
                    <TimeSelector
                        data-testid="time-selector-day-mini-picker"
                        data={data}
                        globalDateOptions={getGlobalDateOptions(platform)}
                        enableResizeObserver
                        variant={getTimeSelectorTimespan(platform)}
                        boxHeight="36px"
                        selectedValue={selectedValue}
                        layout="horizontal"
                    />
                </Grid>
            </Grid>
        </Box>
    );
};
